import { SVGProps } from 'react';

const ParkingNotAvailable = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="102"
    height="103"
    viewBox="0 0 102 103"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="31.7838" cy="36.8736" r="31.4869" fill="#E0DFFF" />
    <circle cx="37.6939" cy="38.2349" r="31.1623" stroke="black" strokeWidth="0.649214" />
    <path
      d="M89.9521 2.85352C95.689 2.85352 100.34 7.50439 100.34 13.2412V32.0684C100.34 37.8051 95.6889 42.4551 89.9521 42.4551H84.9736L78.6943 47.9951C78.2752 48.365 77.6164 48.0677 77.6162 47.5088V42.4551H62.0361C56.2994 42.4551 51.6486 37.8051 51.6484 32.0684V13.2412C51.6484 7.50439 56.2993 2.85352 62.0361 2.85352H89.9521Z"
      fill="#5F59FF"
    />
    <path
      d="M59.5132 74.2477L62.6859 71.6699L64.6056 70.0702C65.6998 69.1583 67.3243 69.298 68.2467 70.3833L86.5667 91.9363C87.7221 93.2955 87.5641 95.3324 86.2129 96.4972L82.2701 99.8962C80.6102 101.327 78.097 101.108 76.7103 99.4105L59.1398 77.9063C58.2306 76.7935 58.3979 75.1539 59.5132 74.2477Z"
      fill="#5F59FF"
    />
    <path
      d="M64.0071 66.6919L60.4417 69.5026L55.9906 63.6055L59.3903 60.7724L64.0071 66.6919Z"
      fill="#5F59FF"
      stroke="black"
      strokeWidth="0.649214"
    />
    <path
      d="M59.8374 70.3532L63.0101 67.7754L64.9298 66.1756C66.024 65.2638 67.6485 65.4035 68.5709 66.4887L86.891 88.0417C88.0463 89.401 87.8883 91.4378 86.5371 92.6026L82.5943 96.0016C80.9344 97.4326 78.4212 97.213 77.0345 95.5159L59.464 74.0117C58.5548 72.899 58.7221 71.2593 59.8374 70.3532Z"
      fill="white"
      stroke="black"
      strokeWidth="0.649214"
    />
    <path d="M75.3477 78.4863L83.7874 88.2245" stroke="black" strokeWidth="0.649214" />
    <mask id="path-8-inside-1_16379_154696" fill="white">
      <path d="M87.3545 0.257812C93.0913 0.257857 97.7422 4.90872 97.7422 10.6455V29.4727C97.7421 35.2094 93.0912 39.8603 87.3545 39.8604H82.375L76.0967 45.3994C75.6775 45.7693 75.0187 45.472 75.0186 44.9131V39.8604H59.4385C53.7017 39.8604 49.0509 35.2094 49.0508 29.4727V10.6455C49.0508 4.90869 53.7017 0.257812 59.4385 0.257812H87.3545Z" />
    </mask>
    <path
      d="M87.3545 0.257812C93.0913 0.257857 97.7422 4.90872 97.7422 10.6455V29.4727C97.7421 35.2094 93.0912 39.8603 87.3545 39.8604H82.375L76.0967 45.3994C75.6775 45.7693 75.0187 45.472 75.0186 44.9131V39.8604H59.4385C53.7017 39.8604 49.0509 35.2094 49.0508 29.4727V10.6455C49.0508 4.90869 53.7017 0.257812 59.4385 0.257812H87.3545Z"
      fill="white"
    />
    <path
      d="M87.3545 0.257812L87.3545 -0.391402H87.3545V0.257812ZM97.7422 29.4727L98.3914 29.4727V29.4727H97.7422ZM87.3545 39.8604V40.5096H87.3545L87.3545 39.8604ZM82.375 39.8604V39.2111H82.1296L81.9455 39.3735L82.375 39.8604ZM76.0967 45.3994L75.6672 44.9126L75.6671 44.9126L76.0967 45.3994ZM75.0186 44.9131H74.3693V44.9133L75.0186 44.9131ZM75.0186 39.8604H75.6678V39.2111H75.0186V39.8604ZM49.0508 29.4727H48.4016V29.4727L49.0508 29.4727ZM87.3545 0.257812L87.3545 0.907027C92.7327 0.907068 97.093 5.26727 97.093 10.6455H97.7422H98.3914C98.3914 4.55016 93.4498 -0.391354 87.3545 -0.391402L87.3545 0.257812ZM97.7422 10.6455H97.093V29.4727H97.7422H98.3914V10.6455H97.7422ZM97.7422 29.4727L97.093 29.4726C97.0929 34.8508 92.7326 39.2111 87.3545 39.2111L87.3545 39.8604L87.3545 40.5096C93.4498 40.5095 98.3913 35.5679 98.3914 29.4727L97.7422 29.4727ZM87.3545 39.8604V39.2111H82.375V39.8604V40.5096H87.3545V39.8604ZM82.375 39.8604L81.9455 39.3735L75.6672 44.9126L76.0967 45.3994L76.5262 45.8862L82.8045 40.3472L82.375 39.8604ZM76.0967 45.3994L75.6671 44.9126L75.6678 44.9129L75.0186 44.9131L74.3693 44.9133C74.3696 46.0312 75.6879 46.6259 76.5262 45.8862L76.0967 45.3994ZM75.0186 44.9131H75.6678V39.8604H75.0186H74.3693V44.9131H75.0186ZM75.0186 39.8604V39.2111H59.4385V39.8604V40.5096H75.0186V39.8604ZM59.4385 39.8604V39.2111C54.0603 39.2111 49.7001 34.8508 49.7 29.4726L49.0508 29.4727L48.4016 29.4727C48.4017 35.5679 53.3432 40.5096 59.4385 40.5096V39.8604ZM49.0508 29.4727H49.7V10.6455H49.0508H48.4016V29.4727H49.0508ZM49.0508 10.6455H49.7C49.7 5.26724 54.0602 0.907027 59.4385 0.907027V0.257812V-0.391402C53.3431 -0.391402 48.4016 4.55014 48.4016 10.6455H49.0508ZM59.4385 0.257812V0.907027H87.3545V0.257812V-0.391402H59.4385V0.257812Z"
      fill="black"
      mask="url(#path-8-inside-1_16379_154696)"
    />
    <path
      d="M66.582 13.8906L80.2155 27.5241"
      stroke="#5F59FF"
      strokeWidth="1.29843"
      strokeLinecap="round"
    />
    <path
      d="M66.582 27.5234L80.2155 13.8899"
      stroke="#5F59FF"
      strokeWidth="1.29843"
      strokeLinecap="round"
    />
  </svg>
);

export default ParkingNotAvailable;
